import { render } from "./TeaserPage.vue?vue&type=template&id=6cf16e9a&scoped=true"
import script from "./TeaserPage.vue?vue&type=script&lang=js"
export * from "./TeaserPage.vue?vue&type=script&lang=js"

import "./TeaserPage.vue?vue&type=style&index=0&id=6cf16e9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf16e9a"]])

export default __exports__